import { HTTPVerbs } from '@nextgen-web-framework/core';
import type { RequestOptions } from '@nextgen-web-framework/core';
import { GetContentPropTypes, GetPagesPropTypes, FetchLivePreviewProps } from '../requests/cmsApi/types/propTypes';

export const CMS_SERVICE_KEY = 'comcontentstackas';
export const API_VERSION = 'v2';

export const getPageReqObj = ({ slug }: GetPagesPropTypes): RequestOptions => ({
  url: `/${CMS_SERVICE_KEY}/${API_VERSION}/pages/${slug}`,
  method: HTTPVerbs.GET,
  retries: 0,
  timeout: 60000,
});

export const getContentReqObj = ({ uId }: GetContentPropTypes): RequestOptions => ({
  url: `/${CMS_SERVICE_KEY}/${API_VERSION}/content/${uId}`,
  method: HTTPVerbs.GET,
  retries: 0,
  timeout: 60000,
});

export const getLivePreviewReqObj = ({ contentType, hash, entryId }: FetchLivePreviewProps): RequestOptions => ({
  url: `/${CMS_SERVICE_KEY}/${API_VERSION}/live-preview/${contentType}?entriesUid=${entryId}&livePreviewHash=${hash}`,
  method: HTTPVerbs.GET,
  retries: 0,
  timeout: 60000,
});
